import { GidAccessControl } from './gid-access-control';
import { PortalRegister } from './portal-register';
import { Auth0Group } from './auth0-group';

export enum enumPortalAccessStatus {
  Allow = 1,
  Deny
}

export namespace enumPortalAccessStatus {
  export function values() {
    return Object.keys(enumPortalAccessStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

export function portalAccessStatusToArray(): object[] {
  return Object.keys(enumPortalAccessStatus)
    .filter(key => typeof enumPortalAccessStatus[key] === 'number')
    .map(key => ({ id: enumPortalAccessStatus[key], itemName: key }));
}

export interface PortalAccess {
  id: number;
  portalRegisterId: number;
  portalName: string;
  portalRegister: PortalRegister;
  status: enumPortalAccessStatus;
  accessControlID: number;
  accessControl: GidAccessControl;
  accessGroup: string;
  authGroupList: [Auth0Group];
  profileNo: string;
  recordDate: string;
  recordTime: string;
}
